import React, { useState, useEffect } from "react";
import useDocumentTitle from "../../../hooks/useDocumentTitle";
import CreditNoteForm from "../components/CreditNoteForm";
import { useLocation, useNavigate } from "react-router-dom";
import { Stack } from "@mui/material";
import { useCreateCreditNoteHandler } from "../dataHandlers/createCreditNoteHandler";
import { usePermissions } from "../../../hooks/usePermissions";
import {
  CREATE_PURCHASE_CREDIT_NOTE,
  CREATE_SALE_CREDIT_NOTE,
} from "../../../constants/eInvoicePermissions";
import { useActionDeniedSnackbar } from "../../../hooks/useActionDeniedSnackbar";

export default function CreateCreditNotePage({ isPurchase = false }) {
  useDocumentTitle("Credit Note Form");
  const navigate = useNavigate();
  const location = useLocation();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const document = location?.state?.invoiceData;
  const source = location?.state?.source;
  const { loading, hasEInvoicePermission } = usePermissions();
  const showActionDeniedSnackbar = useActionDeniedSnackbar();
  const onCreditNoteCreated = () => {
    navigate(
      isPurchase ? "/purchases?tab=credit-notes" : "/sales?tab=credit-notes",
    );
  };
  const isLinkedFlow = source === 'invoice';
  const { onSubmit, error, isPending } = useCreateCreditNoteHandler({
    onSuccess: onCreditNoteCreated,
    isPurchase,
  });
  useEffect(() => {
    if (loading) {
      return;
    }
    const createPermission = isPurchase
      ? CREATE_PURCHASE_CREDIT_NOTE
      : CREATE_SALE_CREDIT_NOTE;
    if (!hasEInvoicePermission(createPermission)) {
      showActionDeniedSnackbar();
      navigate(
        isPurchase ? "/purchases?tab=credit-notes" : "/sales?tab=credit-notes",
        {
          replace: true,
        },
      );
    }
  }, [
    isPurchase,
    loading,
    hasEInvoicePermission,
    showActionDeniedSnackbar,
    navigate,
  ]);


  // Reset isSubmitting when mutation completes
  useEffect(() => {
    if (!isPending && isSubmitting) {
      setIsSubmitting(false);
    }
  }, [isPending, isSubmitting]);

  const onSaveAsEInv = async (payload) => {
    setIsSubmitting(true);
    onSubmit(payload);
  };

  const onCancel = async () => {
    navigate(
      location.state?.from ||
        (isPurchase
          ? "/purchases?tab=credit-notes"
          : "/sales?tab=credit-notes"),
    );
  };

  const { document_number, issue_date, uuid, ...rest } = { ...document };

  return (
    <Stack direction="column" sx={{ mt: "-2rem" }}>
      <CreditNoteForm
        initialData={{
          ...rest,
          billing_reference: [
            {
              id: document_number,
              issue_date: issue_date,
              uuid: uuid,
            },
          ],
        }}
        onSubmit={onSaveAsEInv}
        onCancel={onCancel}
        apiErrors={error}
        isDraftButtonEnabled={location.state?.isDraftButtonEnabled}
        isLoading={isPending || isSubmitting}
        isPurchase={isPurchase}
        isLinkedFlow={isLinkedFlow}
      />
    </Stack>
  );
}
